import { render } from "./DHSchemaInfo.vue?vue&type=template&id=43fbe6f2&scoped=true"
import script from "./DHSchemaInfo.vue?vue&type=script&lang=js"
export * from "./DHSchemaInfo.vue?vue&type=script&lang=js"

import "./DHSchemaInfo.vue?vue&type=style&index=0&id=43fbe6f2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fbe6f2"]])

export default __exports__